export const appPaths = {
  home: '',
  error404: '404',
};

export const appRoutes = {
  home: `/${appPaths.home}`,
  error404: `/${appPaths.error404}`,
};
